import { render, staticRenderFns } from "./shenOutSealDetail.vue?vue&type=template&id=652045f4&"
import script from "./shenOutSealDetail.vue?vue&type=script&lang=js&"
export * from "./shenOutSealDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenOutSealDetail.vue?vue&type=style&index=0&id=652045f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports